import { PageController } from '@client/components/_core/layout/PageController';
import { FieldConfigurationList } from '@client/components/field-configurations/FieldConfigurationList';
import { FIELD_CONFIGURATION_POLICY_SECTION_LABEL } from '@shared/constants';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/console/$orgId/configuration/claims-products/product-types/edit/$productTypeId/policy-fields',
)({
    staticData: {
        presentation: 'overlay',
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <FieldConfigurationList
                entity="PRODUCT_TYPE"
                entityId={Route.useParams().productTypeId}
                section={FIELD_CONFIGURATION_POLICY_SECTION_LABEL}
                allowDuplicates
            />
        </PageController>
    );
}
